module.exports = __webpack_public_path__ + "img/minus.60e6a3bb.svg";